import { createGlobalStyle } from 'styled-components'
import reboot from 'styled-reboot'
import Fonts from './fonts'
import Colors from './colors'
import thirdPartyComponentsStyles from './thirdPartyStyles'

const globalStyles = createGlobalStyle`
  ${reboot()}

  html {
    font-size: 16px;
  }

  body {
    font-family: ${Fonts.fontFamilies.Montserrat};
    font-size: .9375rem;
    font-weight: 500;
    line-height: 1.6;
    text-rendering: optimizeLegibility;
  }

  a,
  a:hover,
  a:visited {
    color: ${Colors.Primary.Black};
  }

  h1 {
    font-size: 2.25rem;
    font-weight: 700;
    line-height: 0.89;
    letter-spacing: -0.5px;
  }

  h2 {
    font-size: 2rem;
    font-weight: 600;
    line-height: 1.13;
  }

  h3 {
    font-size: 1.6875rem;
    font-weight: 600;
    line-height: 1.04;
  }

  h4, h5 {
    font-size: 1.25rem;
    line-height: 1.2;
  }

  h4 {
    font-weight: 600;
  }

  h6 {
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.25;
  }

  button {
    cursor: pointer;
  }

  label {
    margin: 0;
  }

  menu {
    padding-left: 0;
    margin: 0;
  }

  .visuallyHidden {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  .disabled,
  [disabled] {
    color: #666;
    cursor: default;
    pointer-events: none;
  }

  @keyframes spin { 100% { transform: rotate(360deg); } }

  ${thirdPartyComponentsStyles}
`

export default globalStyles
